export default "__VITE_ASSET__D$TG$tWJ__"